<!-- Mobile bottomsheet -->
<button
  *ngIf="showBottomSheetTrigger$ | async"
  matRipple
  matRippleColor="rgba(0, 0, 0, 0.02)"
  class="mobile-bottomsheet-trigger"
  (click)="openMobileBottomSheet()"
  type="button"></button>
<!-- Component Container -->
<div
  class="container"
  [class.secondary-style]="appearance === 'secondary'"
  [class.tertiary-style]="appearance === 'tertiary'"
  [class.condensed-style]="condensed"
  [class.is-multi]="multiple"
  [class.full-width]="isFullWidth"
  [attr.data-test]="'select-wrap-' + (id || '')">
  <!-- Clear Button -->
  <div
    *ngIf="isClearable && (showClear$ | async)"
    class="custom-clear-icon"
    (click)="resetFormSelect()">
    <mat-icon>close</mat-icon>
  </div>
  <!-- Arrow Icon -->
  <div
    class="custom-dropdown-arrow"
    [class.disabled]="control.disabled"
    [class.condensed]="condensed">
    <mg-icon [iconName]="(isOpen$ | async) ? 'mg-chevron-up' : 'mg-chevron-down'"> </mg-icon>
  </div>

  <div
    *ngIf="loading"
    class="loader">
    <mg-spinner
      class="loader"
      [diameter]="30"
      [thickness]="3">
    </mg-spinner>
  </div>

  <label
    *ngIf="showLabel"
    class="input-label focused"
    [ngClass]="labelBackground"
    [class.has-error]="control.invalid && control.touched"
    [class.has-input]="!!control.value">
    {{ placeholder }}
  </label>
  <!-- formControlName="selected" -->
  <ng-select
    class="input-alignment-fix"
    bindLabel="label"
    bindValue="value"
    labelForId="state"
    [placeholder]="displayPlaceholder"
    [notFoundText]="notFoundText"
    [formControl]="$any(control)"
    [class.error]="control.invalid && control.touched"
    [class.valid]="control.valid && control.dirty"
    [class.cursor]="true"
    [class.input-spacing]="!!control.value && control.value.length"
    [ngModel]="currentValue"
    [addTag]="addTag"
    [addTagText]="addTagText"
    [clearable]="isClearable"
    [typeahead]="input$"
    [searchable]="searchable"
    [closeOnSelect]="closeOnSelect"
    [clearSearchOnAdd]="true"
    [loading]="isLoadingObs$ | async"
    [multiple]="multiple"
    [appendTo]="appendTo || null"
    [items]="options"
    [hideSelected]="hideSelected"
    [inputAttrs]="inputAttrs"
    (change)="handleModelChange($event)"
    (open)="open()"
    (close)="setOpenState(false)"
    (blur)="blurEvent.emit()">
    <!-- Multi Select Item template -->
    <ng-template
      *ngIf="!selectContent"
      ng-multi-label-tmp
      let-items="items"
      let-clear="clear">
      <div class="tw-flex tw-gap-1">
        <div
          *ngFor="let option of items | slice: 0:getSelectedItemsToShow"
          class="selected-option">
          <div
            class="label"
            [title]="$any(option).label">
            <span>{{ $any(option).label }}</span>
          </div>
          <span
            class="close"
            (click)="clear(option)">
            <mat-icon>close</mat-icon>
          </span>
        </div>

        <ng-container *ngIf="items.length > getSelectedItemsToShow">
          <div class="selected-option no-close">
            <div class="label">
              <span>{{ items.length - getSelectedItemsToShow }} more</span>
            </div>
          </div>
        </ng-container>
      </div>
    </ng-template>

    <!-- Default Option Template -->
    <ng-template
      *ngIf="!selectContent"
      ng-option-tmp
      let-item="item">
      <div
        matTooltipClass="mg-tooltip"
        matTooltipPosition="right"
        [matTooltip]="showTooltip ? $any(item).label : null">
        {{ $any(item).label }}
      </div>
    </ng-template>

    <ng-container *ngIf="selectContent">
      <ng-template
        ng-option-tmp
        ng-label-tmp
        let-option="item">
        <div
          matTooltipClass="mg-tooltip"
          matTooltipPosition="right"
          [matTooltip]="showTooltip ? $any(option).label : null">
          <ng-template
            [ngTemplateOutlet]="selectContent"
            [ngTemplateOutletContext]="{ item: option }">
          </ng-template>
        </div>
      </ng-template>
    </ng-container>

    <!-- Loading Template -->
    <ng-template ng-loadingspinner-tmp>
      <mg-spinner
        variant="rainbow"
        [diameter]="20"
        [thickness]="2">
      </mg-spinner>
    </ng-template>
  </ng-select>
</div>

<mg-form-error *ngIf="control.invalid && control.touched && !suppressErrorMessage">
  {{ control?.errors | makeInputErrorMessage }}
</mg-form-error>

<div
  *ngIf="hint"
  class="hint">
  <mg-text
    color="surface-alt"
    variant="label-sm">
    {{ hint }}
  </mg-text>
</div>
